import { render, staticRenderFns } from "./potionDetail.vue?vue&type=template&id=26db24fa&scoped=true"
import script from "./potionDetail.vue?vue&type=script&lang=ts"
export * from "./potionDetail.vue?vue&type=script&lang=ts"
import style0 from "./potionDetail.vue?vue&type=style&index=0&id=26db24fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26db24fa",
  null
  
)

export default component.exports